import { Reveal, Eyebrow } from "./Reveal";
import { QuoteForm } from "./QuoteForm";
import { CONTACT } from "../../lib/site";
import { Phone, Mail, MessageCircle } from "lucide-react";

export const InfoGrid = ({ eyebrow, title, items, testId }) => (
  <section data-testid={testId} className="bg-white py-24 sm:py-32">
    <div className="container-x">
      <Eyebrow>{eyebrow}</Eyebrow>
      <Reveal><h2 className="mt-5 max-w-3xl font-display text-4xl font-semibold leading-[0.95] tracking-tight text-forest sm:text-5xl">{title}</h2></Reveal>
      <div className="mt-14 grid gap-px overflow-hidden rounded-[1.75rem] border border-forest/10 bg-forest/10 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((it, i) => (
          <Reveal key={it.title} delay={(i % 3) * 0.06} className="bg-white">
            <article data-testid={`${testId}-item-${i}`} className="group h-full p-8 sm:p-10">
              <span className="font-display text-sm font-medium text-solar-ink">0{i + 1}</span>
              <h3 className="mt-4 font-display text-2xl font-medium leading-tight tracking-tight text-forest">{it.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-ink/75">{it.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const ContactList = ({ light = false }) => (
  <ul className="space-y-3">
    {[
      [CONTACT.phoneHref, Phone, CONTACT.phoneDisplay, "phone", false],
      [CONTACT.whatsappHref, MessageCircle, "WhatsApp", "whatsapp", true],
      [CONTACT.emailHref, Mail, CONTACT.email, "email", false],
    ].map(([href, Icon, label, key, ext]) => (
      <li key={key}>
        <a href={href} {...(ext ? { target: "_blank", rel: "noopener noreferrer" } : {})} data-testid={`contact-${key}-link`}
          className={`group flex items-center gap-4 rounded-2xl border p-4 transition-colors duration-300 ${light ? "border-white/15 text-white hover:bg-white/10" : "border-forest/10 bg-white text-forest hover:border-forest/30"}`}>
          <span className={`grid h-11 w-11 place-items-center rounded-full ${light ? "bg-gold text-forest" : "bg-solar text-white"}`}><Icon className="h-5 w-5" /></span>
          <span className="font-medium">{label}</span>
        </a>
      </li>
    ))}
  </ul>
);

export const QuoteSection = ({ tipo, title, text, origem, lockTipo = false }) => (
  <section id="formulario" data-testid="quote-section" className="bg-paper py-24 sm:py-32">
    <div className="container-x grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <Eyebrow>Pedido de orçamento</Eyebrow>
          <Reveal><h2 className="mt-5 font-display text-4xl font-semibold leading-[0.95] tracking-tight text-forest sm:text-5xl">{title}</h2></Reveal>
          <p className="mt-6 text-ink/75 leading-relaxed">{text}</p>
          <div className="mt-10"><ContactList /></div>
        </div>
      </div>
      <div className="lg:col-span-8"><QuoteForm defaultTipo={tipo} origem={origem} lockTipo={lockTipo} /></div>
    </div>
  </section>
);
